export default __webpack_public_path__ + "static/media/dog.94e4612c.svg";